import React from "react";
import { Routes, Route, useLocation, Navigate, useParams } from 'react-router-dom';
import Home from '../Frontend/Home/Home';
import Nav from '../Main/Navbar/Nav';
import About from '../Frontend/About/About';
import Network from '../Frontend/pages/Network';
import Exhibited from '../Frontend/pages/Exhibited';
import Login from '../Frontend/Membership/Login';
import Signup from '../Frontend/Membership/Signup';
import GoogleAuthSuccess from '../Frontend/Membership/GoogleAuthSuccess';
import Profile from '../../Profile/Profile';
import PublicProfile from '../../Profile/PublicProfile.jsx';
import PartnerSupport from '../Frontend/pages/PartnerSupport';
import AdminLogin from '../Admin/AdminLogin';
import AdminDashboard from '../Admin/Dashboard/Dashboard';
import Insights from '../Frontend/pages/Insights';
import Contact from '../Frontend/Contact/Contact';
import Footer from "../Main/Footer/Footer";
import ScrollToTop from "../UI/ScrollToTop/ScrollToTop";
import Form from "../Modal/Form_Animated/Form";
import { motion, AnimatePresence } from "framer-motion";
import "./Animation.css";
import Loader from '../Loader/Loader';
import { useLoading } from '../../context/LoadingContext';
import { useEffect } from 'react';
import Events from "../Frontend/Events/Events";
import { Media } from "../Frontend/Media/Media";
import Vision from "../Frontend/About/AboutPages/Vision/Vision";
import Founder from "../Frontend/About/AboutPages/Founder/Founder";
import CoFounder from "../Frontend/About/AboutPages/Co-Founder/CoFounder";
import { Ambassadors } from "../Frontend/About/AboutPages/Ambassadors/Ambassadors";
import Advisor from "../Frontend/About/AboutPages/Board_of_Advisor/Advisor";
import Director from "../Frontend/About/AboutPages/Director/Director";
import BlogPage from "../Frontend/Media/MediaPages/Blogs/Blog.jsx";
import Konnect2022 from "../Frontend/Events/EventPages/Konnect/Konnect2022/Konnect2022.jsx";
import Konnects2023 from "../Frontend/Events/EventPages/Konnect/Konnect2023/Konnect2023.jsx";
import AppointmentPage from "../Frontend/Media/MediaPages/Appointment/Appointment.jsx";
import NetworkMultiplier from "../Frontend/Events/EventPages/NetworkMultiplier/NetworkMultiplier.jsx";
import Mentor from "../Frontend/About/AboutPages/Board_of_Mentor/Mentor.jsx";
import Socials from "../Frontend/Events/EventPages/Socials/Socials.jsx";
import { upcomingEvents as socialUpcomingEvents } from "../Frontend/Events/EventPages/Socials/socialsData.js";
import Outreach from "../Frontend/Events/EventPages/Outreach/Outreach.jsx";
import Gallery from "../Frontend/Media/MediaPages/Gallery/Gallery.jsx";
import Stories from "../Frontend/Media/MediaPages/Stories/Stories.jsx";
import TeamLead from "../Frontend/About/AboutPages/Team-Lead/TeamLead.jsx";
import PosterPopup from "../Pop-Up/PosterPopUp.jsx";
import { useGrammarCheck } from "../../context/useGrammarCheck.js";
import WhatsApp from "../Main/Whatsapp/Whatsapp.jsx";

export default function Router() {
  const location = useLocation();
  const { isLoading, setIsLoading } = useLoading();
  useGrammarCheck();

  useEffect(() => {
    setIsLoading(true);
    const minMs = 2500;
    const timer = setTimeout(() => setIsLoading(false), minMs);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div className="app-layout">
      <PosterPopup />
      <Nav />
      <WhatsApp />
      <ScrollToTop />
      {isLoading && <Loader />}
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div>
            <Routes>
              {/* ── Home ── */}
              <Route path="/" element={<Home />} />

              {/* ── About ── */}
              <Route path="/about_us" element={<About />} />
              <Route path="/our_story/vision" element={<Vision withPageMargin={true} />} />
              <Route path="/our_story/founder" element={<Founder />} />
              <Route path="/our_story/co-founder" element={<CoFounder />} />
              <Route path="/our_story/board-of-advisors" element={<Advisor withPageMargin={true} />} />
              <Route path="/our_story/board_of_mentor" element={<Mentor />} />
              <Route path="/our_story/board_of_ambassadors" element={<Ambassadors withPageMargin={true} />} /><Route path="/our_story/teamlead" element={<TeamLead withPageMargin={true} />} />

              {/* ── Events ── */}
              <Route path="/events" element={<Events />} />
              <Route path="/events/rsvp/:city" element={<Events />} />
              <Route path="/events/network_multiplier" element={<NetworkMultiplier />} />
              <Route path="/events/konnect/konnect2022" element={<Konnect2022 />} />
              <Route path="/events/konnect/konnect2023" element={<Konnects2023 />} />
              <Route path="/events/social" element={<Socials />} />
              <Route path="/events/socials" element={<Socials />} />
              <Route path="/events/social/rsvp/:city" element={<Socials />} />
              <Route path="/events/socials/rsvp/:city" element={<Socials />} />
              <Route path="/events/outreach" element={<Outreach />} />

              {/* ── Media ── */}
              <Route path="/media" element={<Media />} />
              <Route path="/media/blog" element={<BlogPage />} />
              <Route path="/media/gallery" element={<Gallery />} />
              <Route path="/media/stories" element={<Stories />} />
              <Route path="/media/news" element={<AppointmentPage />} />

              {/* ── Other pages ── */}
              <Route path="/network" element={<Network />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/exhibited" element={<Exhibited />} />
              <Route path="/partner-support" element={<PartnerSupport />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/form" element={<Form />} />

              {/* ── Auth ── */}
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/google-auth-success" element={<GoogleAuthSuccess />} />
              <Route path="/dashboard" element={<Profile />} />

              {/* ── Admin — MUST be before /:username ── */}
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />

              {/* ── Named profiles — MUST be before /:username ── */}
              <Route path="/abhishekgarg" element={<TeamLead tab="founder" withPageMargin={true} />} />
              <Route path="/punamsingh" element={<TeamLead tab="co-founder" id="co-founder" withPageMargin={true} />} />
              <Route path="/tarunthakral" element={<TeamLead tab="advisors" id="tarun-thakral" withPageMargin={true} />} />
              <Route path="/jahnabiphookan" element={<TeamLead tab="advisors" id="jahnabi-phookan" withPageMargin={true} />} />
              <Route path="/vasudhasondhi" element={<TeamLead tab="ambassadors" id="vasudha-sondhi" withPageMargin={true} />} />
              <Route path="/anilparashar" element={<TeamLead tab="mentors" id="anil-parashar" withPageMargin={true} />} />{/* ── Profile — specific before wildcard ── */}
              <Route path="/profile/:username" element={<Profile />} />

              {/* ── Wildcard — ALWAYS LAST ── */}
              <Route path="/:username" element={<PublicProfile />} />
            </Routes>
          </div>
        </motion.div>
      </AnimatePresence>
      <Footer />
    </div>
  );
}

